/**
 * TreeMap constants doc
 */
/**
 * Triggers when the treemap is on load.
 *
 * @private
 */
export const load = 'load';
/**
 * Triggers after treemap rendered.
 *
 * @private
 */
export const loaded = 'loaded';
/**
 * Trigger before call the print method.
 *
 * @private
 */
export const beforePrint = 'beforePrint';
/**
 * Trigger before each treemap item rendered.
 *
 * @private
 */
export const itemRendering = 'itemRendering';
/**
 * Trigger after click on treemap item.
 *
 * @private
 */
export const drillStart = 'drillStart';
/**
 * Trigger after drill start event completed.
 *
 * @private
 */
export const drillEnd = 'drillEnd';
/**
 * Trigger after select the treemap item.
 *
 * @private
 */
export const itemSelected = 'itemSelected';
/**
 * Trigger after hover on the treemap item.
 *
 * @private
 */
export const itemHighlight = 'itemHighlight';
/**
 * Trigger after mouse hover on the treemap item.
 *
 * @private
 */
export const tooltipRendering = 'tooltipRendering';
/**
 * Trigger after click on the treemap item.
 *
 * @private
 */
export const itemClick = 'itemClick';
/**
 * Trigger after mouse hover on the treemap item.
 *
 * @private
 */
export const itemMove = 'itemMove';
/**
 * Trigger after click on the treemap item.
 *
 * @private
 */
export const click = 'click';
/**
 * Trigger after double click on the treemap item.
 *
 * @private
 */
export const doubleClick = 'doubleClick';
/**
 * Trigger after right click on the treemap item.
 *
 * @private
 */
export const rightClick = 'rightClick';
/**
 * Trigger after mouse hover on the treemap item.
 *
 * @private
 */
export const mouseMove = 'mouseMove';
/**
 * Trigger before each treemap item.
 *
 * @private
 */
export const legendItemRendering = 'legendItemRendering';
/**
 * Trigger before legend items.
 *
 * @private
 */
export const legendRendering = 'legendRendering';
/**
 * Trigger after resize the treemap.
 *
 * @private
 */
export const resize = 'resize';
/**
 * Define the font family in treemap.
 *
 * @private
 */
export const defaultFont = 'Roboto, Segoe UI, Noto, Sans-serif';
